import { Seo } from "@/components/Seo";
import { Img } from "@/components/Img";
import { CtaLink, PageHero, SectionHead } from "@/components/Ui";
import { SupportList, InvestmentSnapshot } from "@/components/Blocks";
import { TerritoryCta } from "@/components/CtaBands";
import { INVESTMENT, SUPPORT } from "@/content/site";

export default function InvestmentSupport() {
  return (
    <>
      <Seo path="/investment-support" />
      <PageHero eyebrow="Investment & Support" title="Franchise Investment, Fees & Support">
        <p>{INVESTMENT.valueText}</p>
      </PageHero>

      <section className="section on-dark border-b border-ivory/10 bg-ink-soft text-ivory">
        <div className="wrap"><InvestmentSnapshot /></div>
      </section>

      <section className="section bg-ivory" aria-labelledby="value-heading">
        <div className="wrap grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-7">
            <SectionHead title={INVESTMENT.valueTitle} id="value-heading"><p>{INVESTMENT.valueText}</p></SectionHead>
            <div className="mt-9"><CtaLink id="investment-explore-franchise">Explore the Franchise</CtaLink></div>
          </div>
          <div className="lg:col-span-5">
            <Img name="team-logo-wall" sizes="(min-width: 1024px) 38vw, 100vw" alt="Two VidaVital Medical team members in front of the clinic logo wall" imgClassName="aspect-[3/2] w-full object-cover" />
          </div>
        </div>
      </section>

      <section className="section bg-white" aria-labelledby="support-heading">
        <div className="wrap grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHead eyebrow={SUPPORT.eyebrow} title={SUPPORT.title} id="support-heading"><p>{SUPPORT.p}</p></SectionHead>
            <p className="mt-6 font-display text-lg font-semibold">{SUPPORT.focus}</p>
          </div>
          <div className="lg:col-span-7">
            <SupportList />
            <p className="mt-8 font-semibold">{SUPPORT.promise}</p>
          </div>
        </div>
      </section>

      <section className="section bg-ivory" aria-labelledby="discuss-heading">
        <div className="wrap grid items-center gap-10 border border-line bg-white p-8 md:grid-cols-2 md:p-12">
          <div>
            <h2 id="discuss-heading" className="h2">{SUPPORT.discussTitle}</h2>
            <p className="lede mt-4">{SUPPORT.discussSub}</p>
          </div>
          <div className="md:justify-self-end"><CtaLink to="/contact?intent=call" id="schedule-introductory-call" variant="ink">Schedule an Introductory Call</CtaLink></div>
        </div>
      </section>

      <TerritoryCta />
    </>
  );
}
